//import React from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectItemById, updaters, deleters } from './homesSlice_old';
import { useParams, useNavigate } from 'react-router-dom';
import { selectAllUsers } from '../users/usersSlice';

import { FeatureForCamelCaseCRUD } from './homesSlice_old';

const EditFormHome = () => {
  const {homeId} = useParams();
  const navigate = useNavigate(); /* useNavigate added */

  const home = useSelector((state) => selectItemById(state, Number(homeId)));
  const users = useSelector(selectAllUsers);
  
  
  const [title, setTitle] = useState(home?.title); /* Use state uses a parameter: post?param */
  const [content, setContent] = useState(home?.body);
  const [userId, setUserId] = useState(home?.userId);
  const [main, setMain] = useState(home?.main);
  const [pilar, setPilar] = useState(home?.pilar);
  const [requestStatus, setRequestStatus] = useState('idle');
  
  const dispatch = useDispatch();
    
  if(!home){
    return(
      <section>
        <h2>Home not found!</h2>
      </section>
    )
  }

  const onTitleChange = e => setTitle(e.target.value);
  const onContentChange = e => setContent(e.target.value);
  const onAuthorChange = e => setUserId(Number(e.target.value));
  const onMainTitleChange = e => setMain(e.target.value);
  const onPilarChange = e => setPilar(Number(e.target.value));
  const canSave = [title, content, userId].every(Boolean) && requestStatus === 'idle';


  const onSaveHomeClicked = () => {
    if(canSave) {
      try{
        setRequestStatus('pending');
        dispatch(updaters[`update${FeatureForCamelCaseCRUD}`]({id: home.id, title, content, userId, main, pilar})).unwrap(); /* reactions: post.reactions  id reactions added in this form not in the addForm */

        setUserId('');
        setTitle('');
        setContent('');
        navigate(`/homes/${homeId}`)
      }catch(err){
        console.error('Failed to save the home', err)
      }finally{
        setRequestStatus('idle')
      }
      
    }
  }

  const onDeleteHomeClicked = () => {
    try{
      setRequestStatus('pending');
      dispatch(deleters[`delete${FeatureForCamelCaseCRUD}`]({ id: home.id })).unwrap(); /* only the id in the deleteForm ; use unwrap so that to be still able to use try/catch*/

      setUserId('');
      setTitle('');
      setContent('');
      navigate(`/homes/${homeId}`);
      navigate('/');
    }catch(err){
      console.error('Failed to save the home', err)
    }finally{
      setRequestStatus('idle')
    }
    
  }

  const handleKeyDown = (e) => {
    if(e.key === 'Enter'){
      e.prevent.default();
      onSaveHomeClicked()
    }
  }

  const usersOptions = users.map((user) => (
    <option 
      value={user.id} 
      key={user.id}
    >
      {user.name}
    </option>
  ))


  return (
    <div className="container">
      <h2>Edit Home</h2>
      <Form onSubmit={onSaveHomeClicked} name={`homesmainlist-${home.id}`}>
      <Form.Control 
          type="checkbox"
          id="mainTitle"
          name="main"
          placeholder="Should the title be featured"
          value={main} 
          onChange={onMainTitleChange} 
        />
        {/* <label htmlFor="postAuthor">Author</label> */}
        <Form.Control as="select" 
          name="homeAuthor" 
          id="homeAuthor"
          defaultValue={userId} /* Instead of value */
          onChange={onAuthorChange}
        >
          <option value=""></option>
          {usersOptions}
        </Form.Control>
        {/* <label htmlFor="title">Title</label> */}
        <Form.Control 
          type="text"
          id="homeTitle"
          name="title"
          value={title}
          onChange={onTitleChange} 
        />
        <Form.Control 
          type="text"
          id="pilar"
          name="pilar"
          placeholder="Your homePost pilar"
          value={title}
          onChange={onPilarChange} 
          onKeyDown={handleKeyDown}
        />
        {/* <label htmlFor="content">Content</label> */}
        <Form.Control as="textarea" 
          type="text"
          id="homeContent"
          name="content"
          value={content}
          onChange={onContentChange} 
          onKeyDown={handleKeyDown}
        />
        <Button
          type='button'
          /* onClick={onSaveHomeClicked} */
          disabled={!canSave}
          size="block"
        >Save post
        </Button>
        <Button
          type='button'
          onClick={onDeleteHomeClicked}
          variant="outline-warning"
          size="block"
          name={`homeslist-${home.id}`}
        >Delete post
        </Button>
      </Form>
    </div>
  )
}

export default EditFormHome